import { Link, useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Mark } from "./Logo";
import { scrollToTarget, useClock } from "../lib/smooth";

const links = [
  { id: "work", label: "Work" },
  { id: "experience", label: "Experience" },
  { id: "education", label: "Education" },
  { id: "contact", label: "Contact" },
];

export const Nav = () => {
  const time = useClock();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const go = (id) => (e) => {
    e.preventDefault();
    if (pathname !== "/") navigate(`/#${id}`);
    else scrollToTarget(`#${id}`);
  };
  return (
    <motion.header
      initial={{ y: -30, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className="fixed inset-x-0 top-0 z-50 mix-blend-difference text-white"
      data-testid="site-nav"
    >
      <div className="flex items-center justify-between px-5 py-4 md:px-10 md:py-6">
        <Link to="/" onClick={() => pathname === "/" && scrollToTarget(0)} className="flex items-center gap-3" data-testid="nav-monogram-logo">
          <Mark className="h-7 w-7 text-white [--paper:#000] [--accent:#2DB6E0]" />
          <span className="hidden font-mono text-[11px] uppercase tracking-[0.22em] sm:inline">Ravin Patel</span>
        </Link>
        <nav className="flex items-center gap-4 font-mono text-[11px] uppercase tracking-[0.18em] md:gap-8">
          {links.map((l) => (
            <a key={l.id} href={`/#${l.id}`} onClick={go(l.id)} className={`nav-link ${l.id === "education" || l.id === "experience" ? "hidden md:inline" : ""}`} data-testid={`nav-${l.id}-link`}>
              {l.label}
            </a>
          ))}
          <span className="hidden tabular-nums lg:inline" data-testid="nav-clock">UK {time}</span>
        </nav>
      </div>
    </motion.header>
  );
};
